<div>
      <relation-list  [name]="'All Users'"  [canAll]=true ></relation-list>
</div>
